export default __webpack_public_path__ + "static/media/Lautaro.c939547c.jpeg";